if (!customElements.get('custom-feeding-calculator')) {
  class customProductOptions extends HTMLElement {
    constructor() {
      super();

      var thisElement = this;
      this.requiredOption = this.querySelectorAll('.required-option')
      this.numberDots = this.querySelectorAll('.number-dots');
      this.continueButton = this.querySelectorAll('.js-continue__button');
      this.jsSteps = this.querySelectorAll('.calculator-js__steps');
      this.customSelect = this.querySelectorAll('.button-select__option');
      this.customSelectValue = this.querySelectorAll('.select-option__value');
      this.svgImages = this.querySelectorAll('.svg-images');
      this.steps = this.querySelectorAll('.number-dots');

       // for skip first step
       if (new URL(location.href).searchParams.has('skip-first')) {
        document
          .querySelector('.calculator-main-step__block')
          .classList.add('active')
      } else {
        document.querySelector('.step-getting-started').classList.add('active')
      }

      if(this.steps){
        this.steps.forEach(function(button) {
          button.addEventListener('click', function() {
            if(this.classList.contains('completed')){
              var thisStep = parseInt(this.dataset.step) + 1;
              var thisStepString = 'calculator-step-'+thisStep;
              thisElement.jsSteps.forEach(function(steps) {
                var getSteps = steps.dataset.step;
                if(thisStepString == getSteps){
                  steps.classList.add('active');
                }else{
                  steps.classList.remove('active');
                }
              });
            }
          });
        });
      }
      this.continueButton.forEach(function(button) {
        button.addEventListener('click', function() {
          var getPetName = document.getElementById('pet-name').value;
          if(getPetName != '') {
            document.getElementById('result-final-name-1').textContent = getPetName;
            document.getElementById('result-final-name-2').textContent = getPetName;
            document.getElementById('result-final-name-3').textContent = getPetName;
            document.getElementById('result-final-name-4').textContent = getPetName;
          }
          if(document.querySelector('.step-getting-started').classList.contains('active')){
            document.querySelector('.step-getting-started').classList.remove('active');
            document.querySelector('.calculator-main-step__block').classList.add('active');
          }
          var buttonStep = this.dataset.step;
          var activeStep = parseInt(this.dataset.activeStep);
          if(buttonStep === 'close'){
            window.location.reload();
          }
          var petTypeElement = document.querySelector('[name="pet-type"]:checked');
          var petSizeElement = document.querySelector('[name="pet-size"]:checked');
          if (petTypeElement && petTypeElement.value == 'Cat') {
            if(buttonStep == 'calculator-step-2'){
              buttonStep = 'calculator-step-3';
              activeStep = 1;
              if(this.classList.contains('button--secondary')){
                buttonStep = 'calculator-step-1';
                activeStep = 0;
              }
            }else if(buttonStep == 'calculator-step-3'){
              activeStep = 1;
            }else if(buttonStep == 'calculator-step-4'){
              activeStep = 2;
            }else if(buttonStep == 'calculator-step-5'){
              activeStep = 3;
            }else if(buttonStep == 'calculator-step-6'){
              activeStep = 4;
            }else if(buttonStep == 'calculator-step-7'){
              activeStep = 5;
            }
          }
          if(petTypeElement && petTypeElement.value == 'Dog'){
            thisElement.classList.remove('pet-size-small');
            thisElement.classList.remove('pet-size-medium');
            thisElement.classList.remove('pet-size-large');
            if(petSizeElement && petSizeElement.value == 'Small'){
               thisElement.classList.add('pet-size-small');
            }else if(petSizeElement && petSizeElement.value == 'Medium'){
               thisElement.classList.add('pet-size-medium');
              if(document.getElementById('pet-age').getAttribute('number') == 6){
                document.getElementById('pet-age').textContent = '1-15 months';
              }
            }else if(petSizeElement && petSizeElement.value == 'Large'){
              thisElement.classList.add('pet-size-large');
              if(document.getElementById('pet-age').getAttribute('number') == 6){
                document.getElementById('pet-age').setAttribute('number', 12);
                document.getElementById('pet-age').textContent = '1-24 months';
              }
            }
          }
          
          thisElement.jsSteps.forEach(function(steps) {
            var getSteps = steps.dataset.step;
            if(buttonStep == getSteps){
              steps.classList.add('active');
            }else{
              steps.classList.remove('active');
            }
          });
          thisElement.numberDots.forEach(function(item,index) {
            if(index < activeStep){
              item.classList.add('completed');
              item.classList.remove('active');
            }else if(index == activeStep){
              item.classList.remove('completed');
              item.classList.add('active');
            }else{
              item.classList.remove('completed');
              item.classList.remove('active');
            }
          });
          if(buttonStep == 'calculator-final-stage'){
            var petName = document.getElementById('pet-name').value;
            var petTypeElement = document.querySelector('[name="pet-type"]:checked');
            var specialCondition = document.getElementById('special-condition').textContent;
            var petWight = parseFloat(document.getElementById('pet-weight').value);
            var petSizeElement = document.querySelector('[name="pet-size"]:checked');
            var petWightTypeElement = document.querySelector('[name="pet-weight"]:checked');
            var mealsPerDay = document.getElementById('meals-per__day').textContent;
            var bodyConditionElement = document.querySelector('[name="your-pet-size"]:checked');
            var petAge = document.getElementById('pet-age').textContent;
            var petAgeText = document.getElementById('pet-age').textContent;
            var emailId = document.getElementById('email-address').value
            var calorie = document.getElementById('calorie').value
            var petWightType = '';
            var origionalPetWeight = petWight;
            var petSpecies = '';
            var bodyCondition = '';
            var petSize = '';
            var bcs = '';
            if (petSizeElement) {
              petSize = petSizeElement.value;
            } 
            if (petTypeElement) {
              petSpecies = petTypeElement.value;
            } 
            if (petWightTypeElement) {
              petWightType = petWightTypeElement.value;
            }
            if (bodyConditionElement) {
              bodyCondition = bodyConditionElement.value;
              bcs = bodyConditionElement.dataset.value;
            }
            var activeColor = 'active-color-1';
            if(bodyCondition == 'Normal / Ideal'){
              var activeColor = 'active-color-2';
            }else if(bodyCondition == 'Slightly Overweight'){
              var activeColor = 'active-color-3';
            }else if(bodyCondition == 'Obese / Overweight'){
              var activeColor = 'active-color-4';
            }
            document.getElementById('result-pet-name').textContent = petName;
            document.getElementById('result-final-name').textContent = petName;
            document.getElementById('result-pet-species').textContent = petSpecies;
            document.getElementById('result-pet-age').textContent = petAge;
            document.getElementById('result-pet-special-condition').textContent = specialCondition;
            document.getElementById('result-pet-weight').textContent = origionalPetWeight+petWightType;
            document.getElementById('result-pet-meals').textContent = mealsPerDay+' Per Day';
            document.getElementById('result-body__condition').textContent = bodyCondition;
            document.querySelector('.list-color__column').classList.add(activeColor);
            document.querySelector('.body-condition__info').classList.add(activeColor);
            petAge = document.getElementById('pet-age').getAttribute('number');
            // Convert weight to kg if necessary
            if (petWightType === 'lb') {
                petWight = petWight / 2.20462;  // Convert lbs to kg
            }
    
            let lsf = 1.0;
    
            if (petSpecies === 'Cat') {
                if (specialCondition === 'Gestation') lsf = 1.8;
                else if (specialCondition === 'Lactating') lsf = 4.0;
                else if (petAge <= 12) lsf = 2.5;
                else {
                    if (bcs === 1) lsf = 1.6;
                    else if (bcs === 2 && specialCondition === 'Neutered / Spayed') lsf = 1.3;
                    else if (bcs === 2 && specialCondition === 'None') lsf = 1.5;
                    else if (bcs === 3) lsf = 1.0;
                    else if (bcs === 4) lsf = 0.8;
                }
            } else if (petSpecies === 'Dog') {
                if (specialCondition === 'Gestation') lsf = 2.4;
                else if (specialCondition === 'Lactating') lsf = 4.5;
                else if (specialCondition === 'Working Dog (Police Dog, Thearpy Dog, etc.)') lsf = 5.0;
                else if (petAge <= 4) lsf = 3.0;
                else if (petSize === 'Small' && petAge <= 12) lsf = 2.0;
                else if (petSize === 'Medium' && petAge <= 15) lsf = 2.0;
                else if (petSize === 'Large' && petAge <= 24) lsf = 2.0;
                else {
                    if (bcs === 1) lsf = 1.5;
                    else if (bcs === 2 && specialCondition === 'Neutered / Spayed') lsf = 1.5;
                    else if (bcs === 2 && specialCondition === 'None') lsf = 1.7;
                    else if (bcs === 3) lsf = 1.1;
                    else if (bcs === 4) lsf = 1.0;
                }
            }
    
            const rer = 70 * Math.pow(petWight, 0.75);
            const mer = rer * lsf;
            const dailyFeedingAmountKg = mer / calorie;
            const dailyFeedingAmountG = dailyFeedingAmountKg * 1000;
            const dailyFeedingAmount = Math.round(dailyFeedingAmountG);
            const mealsNumber = parseInt(mealsPerDay.replace(/\D/g, ''));
            const dailyFeedingFarmula = dailyFeedingAmount/mealsNumber;
            const finalCaloriesPerDay =  `${dailyFeedingAmount} g/ day`;
            document.getElementById('calori-per__day').textContent = finalCaloriesPerDay;
            document.getElementById('calculated-recommended_farmula').textContent = dailyFeedingFarmula.toFixed(2)+' g/ Per Meal';
            document.querySelector('.calculator-main-step__block').classList.remove('active');
            //return false;
            if(emailId != '') {
              let data = {
                emailId: emailId,
                petName: petName,
                petSpecies: petSpecies,
                petAge: petAgeText,
                specialCondition: specialCondition,
                origionalPetWeight: origionalPetWeight+petWightType,
                mealsPerDay: mealsPerDay+' Per Day',
                bodyCondition: bodyCondition,
                finalCaloriesPerDay: finalCaloriesPerDay,
                dailyFeedingFarmula: dailyFeedingFarmula.toFixed(2)+' g/ Per Meal'
              };
              fetch('https://dev.shopifyexperthelp.com/app/rt-custom/pawsync/index.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
              })
              .then(response => response.text())
              .then(data => {
                document.querySelector('.calculator-main-step__block').classList.remove('active');
              })
              .catch((error) => {
                  alert("There was an error sending the data. Please try again.");
                  window.location.reload();
              });

            }
          }
          thisElement.scrollIntoView({ behavior: 'smooth' });
        });
      });
      this.svgImages.forEach(function(svgImage) {
        svgImage.addEventListener('click', function(event) {
          var closestElement = this.closest('.radio-button');
          closestElement.querySelector('label').click();
        });
      });
      this.requiredOption.forEach(function(optionType) {
        if(optionType.tagName == 'INPUT'){
          optionType.addEventListener('change', function(event) {
            var getClosestStep = this.closest('.calculator-js__steps');
            thisElement._requiredOption(getClosestStep);
            if(this.name === 'pet-type' && this.value == 'Cat'){
              thisElement.classList.add('pet-type-cat');
              thisElement.classList.remove('pet-type-dog');
              if(thisElement.querySelector('#special-condition').textContent == 'Working Dog (Police Dog, Thearpy Dog, etc.)'){
                thisElement.querySelector('#special-condition').textContent = 'None';
              }
              
            }else if(this.name === 'pet-type' && this.value == 'Dog'){
              thisElement.classList.remove('pet-type-cat');
              thisElement.classList.add('pet-type-dog');
            }
            if(this.name === 'your-pet-size'){
              thisElement.setAttribute("data-pet-type", this.value);
            }
          });
          optionType.addEventListener('input', function(event) {
            var getClosestStep = this.closest('.calculator-js__steps');
            thisElement._requiredOption(getClosestStep);
          });
        }
      });
      this.customSelect.forEach(function(button) {
        button.addEventListener('click', function(event) {
          var elements = document.querySelectorAll('.select-options');
          var getClosestSelect = this.closest('.select-options');
          elements.forEach(function(element) {
            if(getClosestSelect != element) {
              element.classList.remove('active');
            }
          });
          getClosestSelect.classList.toggle('active');
        });
      });
      this.customSelectValue.forEach(function(optionValue) {
        optionValue.addEventListener('click', function(event) {
          var getClosestSelect = this.closest('.select-options');
          var thisValue = this.dataset.value;
          var thisValueNumber = this.dataset.number;
          if (getClosestSelect) {
            var selectedOption = getClosestSelect.querySelector('.option-selected__value');
            if (selectedOption) {
              selectedOption.textContent = thisValue;
              selectedOption.setAttribute('number',thisValueNumber);
            }
          }
          getClosestSelect.classList.remove('active');
        });
      });
    }
    _requiredOption(element){
      var checkValidation = true;
      var thisElement = this;
      element.querySelectorAll('.required-option').forEach(function(optionType) {
        if(optionType.type === 'text' && optionType.value == ''){
          checkValidation = false;
        }
        if(optionType.type === 'number' && optionType.value == ''){
          checkValidation = false;
        }
        if(optionType.type === 'radio' && !Array.from(element.querySelectorAll('input[type="radio"]')).some(radio => radio.checked)) {
          checkValidation = false;
        }
        if(optionType.type === 'email' && !thisElement.validateEmail(optionType.value)) {
          checkValidation = false;
        }
        if(optionType.type === 'checkbox' && optionType.checked === false){
          checkValidation = false;
        }
      });
      if(checkValidation == true){
        element.querySelector('.js-continue__button').classList.remove('disabled');
      }else{
        element.querySelector('.js-continue__button').classList.add('disabled');
      }
    }
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(String(email).toLowerCase());
    }
  }
  customElements.define('custom-feeding-calculator', customProductOptions);
}     

document.addEventListener("DOMContentLoaded", function() {
  Fancybox.bind("[data-fancybox]", {
    Thumbs: {
      autoStart: true,
    },
    Toolbar: {
      display: ["zoom", "close"],
    },
  });
  Fancybox.bind("[data-fancybox-cat]", {
    Thumbs: {
      autoStart: true,
    },
    Toolbar: {
      display: ["zoom", "close"],
    },
  });
});
// $(".custom-image-slider").flickity({
//   wrapAround: true,
//   pageDots: false,
//   initialIndex: 1,
//   accessibility: true, //true by default
//   autoPlay: false // advance cells every 3 seconds
// });
